module.exports = __webpack_public_path__ + "media/images/logo/Logo(V)_Navy-ef927d604053cedc6a089e4dca665ec4.png";